import React, { Component } from 'react';

class ContainerRight extends Component {
    constructor(props){
        super(props);
        this.state = {
            collRight: [
                {
                    id: 1,
                    subtitle: 'Capítulo 5',
                    title: 'Control de Sistemas Dinámicos Discretos',
                    text: 'Este capítulo aborda la evolución de la teoría de control y los principios de estabilidad en sistemas discretos. Se estudian la respuesta al escalón, el diseño frecuencial en lazo cerrado y los fundamentos de sistemas MIMO.'
                },
                {
                    id: 2,
                    /*subtitle: 'Capítulo 5',*/
                    title: 'Control Adaptativo y Técnicas Avanzadas',
                    text: 'Se presentan métodos de control basados en realimentación de estados, control no lineal bajo incertidumbre y estrategias modernas como el aprendizaje concurrente y el control adaptativo con variaciones estocásticas.'
                },
                {
                    id: 3,
                    /*subtitle: 'Capítulo 5',*/
                    title: 'Aplicaciones Prácticas en MATLAB',
                    text: 'Incluye ejemplos de simulación en MATLAB para implementar controladores adaptativos y evaluar su desempeño en escenarios reales, incluso en presencia de saturación y errores de actuación.'
                }
            ]
        }
    }
    render() {
        return (
            <div className="chapter-list border-right-0">
                 {
                    this.state.collRight.map((data,i) => (
                        <div className="chapter-item" key={i}>
                            <h4><span>{data.subtitle} </span> {data.title}</h4>
                            <p>{data.text} </p>
                        </div>
                    ))
                }
            </div>
        );
    }
}

export default ContainerRight;
